import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

/**
 * Breadcrumb component for displaying Govuk design system navigation links.
 * 
 * @example
 * <govuk-ui-breadcrumb [items]="[{ text: 'Home', href: '/' }, { text: 'About', href: '/about' }]"></govuk-ui-breadcrumb>
 */
@Component({
	selector: 'govuk-ui-breadcrumb',
	standalone: true,
	imports: [
		CommonModule,
		RouterLink
	],
	templateUrl: './breadcrumb.component.html',
	styleUrl: './breadcrumb.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
	/**
	 * Breadcrumb items to display.
	 * Each item should have a `text` and `href` property.
	 */
	@Input() items: { text: string; href: string }[] = [];
}
